export default __webpack_public_path__ + "28a80ff4227dbac817d6fc0836c6d2d3.png";